import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth, type FeatureKey } from './AuthContext';

export function FeatureRoute({ feature, children }: { feature: FeatureKey; children: ReactNode }) {
  const { user } = useAuth();
  if (!window.CLOUD_RUNTIME) {
    return feature === 'fabric-tryon' || feature === 'fabric-display'
      ? <Navigate to="/" replace />
      : children;
  }
  return user?.featureKeys.includes(feature) ? children : <Navigate to="/" replace />;
}
